<template>
  <v-app>
    <v-toolbar color="blue darken-2" flat clipped-left app>
      <v-toolbar-side-icon @click="showNav = !showNav"></v-toolbar-side-icon>
      <v-flex shrink>
        <router-link to="/index/home">
          <v-img :src="require('../../assets/logo.png')" alt="logo" height="40px" width="120px"></v-img>
        </router-link>
      </v-flex>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat class="hidden-xs-only">Welcome, {{email}}</v-btn>
        <v-btn flat @click="logOut()">Logout</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer v-model="showNav" app dark clipped temporary>
      <v-list>
        <v-list-group prepend-icon="home">
          <v-list-tile slot="activator"><v-list-tile-title>Admin</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in Admins" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="folder_open">
          <v-list-tile slot="activator"><v-list-tile-title>Users</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in users" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="widgets">
          <v-list-tile slot="activator"><v-list-tile-title>Products</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in products" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="group">
          <v-list-tile slot="activator"><v-list-tile-title>Groups</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in groups" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="arrow_upward">
          <v-list-tile slot="activator"><v-list-tile-title>Withdrawal</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in withdrawals" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="share">
          <v-list-tile slot="activator"><v-list-tile-title>Referrals</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in referrals" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="subscriptions">
          <v-list-tile slot="activator"><v-list-tile-title>Subscriptions</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in subscriptions" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="settings">
          <v-list-tile slot="activator"><v-list-tile-title>Settings</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in settings" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="payment">
          <v-list-tile slot="activator"><v-list-tile-title>Paystack</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in paystack" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

        <v-list-group prepend-icon="description">
          <v-list-tile slot="activator"><v-list-tile-title>Documentation</v-list-tile-title></v-list-tile>
          <v-list-tile v-for="(item,i) in documentation" :key="i" @click="showNav=false">
            <v-list-tile-title><router-link class="link" :to="item.route">{{item.name}}</router-link></v-list-tile-title>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    showNav: false,
    Admins: [
      { name: 'Create Role', route: '/index/create-role' },
      { name: 'Show All Roles', route: '/index/all-roles' },
      { name: 'Create Permission', route: '/index/create-permission' },
      { name: 'Show All Permissions', route: '/index/all-permissions' },
      { name: 'Create Admin', route: '/index/create-admin' },
      { name: 'Show All Admins', route: '/index/show-all-admins' },
    ],
    referrals: [{ name: 'All Referrals', route: '/index/all-referrals' }],
    subscriptions: [
      { name: 'All Subscriptions', route: '/index/all-subscriptions' },
      { name: 'Failed Subscriptions', route: '/index/failed-subscriptions' },
    ],
    users: [
      { name: 'All Users', route: '/index/all-users' },
      { name: 'All Transactions', route: '/index/all-transactions' },
      { name: 'Credit User', route: '/index/credit-account' },
      { name: 'Debit User', route: '/index/debit-account' },
      { name: 'User Login', route: '/index/login-details' },
      { name: 'API Reference', route: '/index/api-credit-user-acct' },
    ],
    products: [
      { name: 'All Products', route: '/index/all-user-products' },
      { name: 'Move users', route: '/index/move-users' },
      {
        name: 'Create Product Category',
        route: '/index/create-product-category',
      },
      {
        name: 'View All Product Categories',
        route: '/index/get-product-categories',
      },
      {
        name: 'Funded Products',
        route: '/index/all-funded-user-products',
      },
      {
        name: 'UnFunded Products',
        route: '/index/all-unfunded-user-products',
      },
      {
        name: 'Product Earnings',
        route: '/index/product-earnings',
      },
      {
        name: 'Users Active Products',
        route: '/index/users-active-products',
      },
      {
        name: 'Users Inactive Products',
        route: '/index/users-inactive-products',
      },
    ],
    groups: [
      { name: 'All Groups', route: '/index/get-group-product' },
    ],
    withdrawals: [
      { name: 'Withdrawal Details', route: '/index/withdrawal-details' },
    ],
    settings: [
      { name: 'Enable/Disable/Finalize OTP', route: '/index/otp-handler' },
      { name: 'Update Password', route: '/index/update-password' },
    ],
    paystack: [{ name: 'Run Callback', route: '/index/paystack-callback' }],
    documentation: [{ name:'Kolobox Documentation', route: '/index/documentation' }],
    email: null,
  }),
  computed: {
    ...mapGetters(['account']),
  },
  methods: {
    logOut() {
      this.$auth.logout(this, '/');
      // Close Pouch DB
      this.$pouch.close();
    },
  },
  created() {
    this.email = localStorage.getItem('email');
  },
};
</script>

<style>
.container.fluid {
  margin: 0 !important;
  padding: 0 !important;
}
.v-btn__content {
  color: white !important;
}
.link {
  text-decoration: none !important;
  color: white !important;
  margin-left: 50px !important;
}
</style>
